'use strict';

var angular = require('angular');

import '../app';

import './search-service';